
import {makeRequest} from '../../../utils/helpers/helperMethods/makeRequest';
import UseAuthConfig from "../../../hooks/useAuthConfig";
import { CreateUserParams, DeleteTempCallRecordingResourceParams, GetResourceFileParams, GetSingleUserParams, GetTempCallRecordingResourceParams, GetUsersParams, UpdateUserParams, UploadFileParams, UploadTempCallRecordingParams } from "../types";

export async function getUsers({
    PageNumber,
    SearchText,
    SortOrder,
    PageSize,
    OrderBy,
    ParameterOne,
    ParameterTwo,
    ParameterThree,
    url,
    accessToken
}: GetUsersParams) {
    try {
        const { protectedResources }: any = UseAuthConfig();
        const endpoint = `${protectedResources.apiTodoList.endpoint}/users?PageSize=${PageSize}&PageNumber=${PageNumber}&SearchText=${SearchText}&OrderBy=${OrderBy}&SortOrder=${SortOrder}&ParameterOne=${ParameterThree}&ParameterTwo=${ParameterTwo}`;
        const response = await makeRequest(accessToken, endpoint, 'GET', null, '');
        if (response.ok) {
            return response.json();
        } else {
            throw new Error("Users get Failed");
        }
    } catch (e) {
        throw new Error("Users get Failed");
    }
}

export async function getUsersClients({
    PageNumber,
    SearchText,
    SortOrder,
    PageSize,
    OrderBy,
    ParameterOne,
    ParameterTwo,
    ParameterThree,
    url,
    accessToken
}: GetUsersParams)  {
    try {
        const { protectedResources } : any = UseAuthConfig();
        let endpoint = `${protectedResources.apiTodoList.endpoint}/accounts?PageSize=${PageSize}&PageNumber=${PageNumber}&SearchText=${SearchText}&OrderBy=${OrderBy}&SortOrder=${SortOrder}&ParameterOne=${ParameterThree}`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'GET', null, ''));
        if (response.ok){
            return response.json();
        }else {
            throw new Error("Users get Failed");
        }
    } catch (e) {
        throw new Error("Users get Failed");
    }
}



export async function getSingleClient({accessToken,url} : GetSingleUserParams) {
  try {
    const response = await  ( await  makeRequest(accessToken, url, 'GET', null, ''));
    if (response.ok){
      return  response.json();
    }else {
      throw new Error("Job get Failed");
    }
  } catch (e) {
    throw new Error("Job get Failed");
  }
}

export async function getSingleAccount({accessToken,url} : GetSingleUserParams) {
    try {
      const response = await  ( await  makeRequest(accessToken, url, 'GET', null, ''));
      if (response.ok){
        return  response.json();
      }else {
        throw new Error("Job get Failed");
      }
    } catch (e) {
      throw new Error("Job get Failed");
    }
  }

  
export async function CreateUser({accessToken,url,user} : CreateUserParams){
    try {
        let endpoint = `${url}/users`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'POST', user, ''));
        if (response.ok){
            return {status:"success", message:  "User created success", data: response.json()};
        }else {
            throw new Error("User create failed");
        }
    }catch (e) {
        throw "User create failed"
    }
}

export async function UpdateUser({accessToken, selectedFile, url, user}: UpdateUserParams) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'PUT', user, selectedFile));
        if (response.ok){
            return {status:"success", message:  "User updated success", data: response.ok};
        }else {
            throw new Error("User update failed");
        }
    }catch (e) {
        throw "User Update failed"
    }
}

export async function UpdateCurrentUser({accessToken, selectedFile, url, user}: UpdateUserParams) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'POST', user, selectedFile));
        if (response.ok){
            return {status:"success", message:  "User updated success", data: response.ok};
        }else {
            throw new Error("User update failed");
        }
    }catch (e) {
        throw "User Update failed"
    }
}


export async function UploadFile({Reference,ReferenceId,accessToken,selectedFile,url}: UploadFileParams) {
    try {
        const response = await  ( await  makeRequest(accessToken, url + `?Reference=${Reference}&Type=2&ReferenceId=${ReferenceId}`, 'POST', null , selectedFile));
        const dataResult = await response.json();
        if (response.ok){
            return {status:"success", message:  "User update success" , name: dataResult?.data?.name};
        }
    }catch (e) {
        throw "File upload failed"
    }
}

export async function uploadTempCallRecording({accessToken,selectedFile,url}: UploadTempCallRecordingParams) {
    try {
        const response = await  ( await  makeRequest(accessToken, url + "/resources/upload-temp-file", 'POST', null , selectedFile));
        const dataResult = await response.json();
        if (response.ok){
            const expiryTime = Date.now() + (60 * 60 * 1000); // 1 hour
            localStorage.setItem("recordingFile", dataResult?.data?.name);
            localStorage.setItem("existingRecording", expiryTime.toString());
            return {status:"success", message:  "User update success" , name: dataResult?.data?.name};
        }
    }catch (e) {
        throw "File upload failed"
    }
}

export async function deleteTempCallRecordingResource({accessToken, url, name}: DeleteTempCallRecordingResourceParams) {
    try {
        const response = await  ( await  makeRequest(accessToken, url + "/resources/delete-temp-file?"+`blobName=${name}`, 'DELETE', null , null));
        const dataResult = await response.json();
        if (response.ok){
            console.log("File deleted successfully");
            localStorage.removeItem("recordingFile");
            return dataResult;
        }
    }catch (e) {
        throw "File Delete failed"
    }
}

export async function getTempCallRecordingResource({
  accessToken,
  url,
  name
}: GetTempCallRecordingResourceParams) {
  try {
    const response = await makeRequest(
      accessToken,
      url + "/resources/get-temp-file?"+`blobName=${name}`,
      "GET",
      null,
      null
    );

    const dataResult = await response.json();

    if (response.ok) {
        console.log("dataResult", dataResult?.data?.name);
        localStorage.setItem("recordingFile", dataResult?.data?.name);
      return {
        content: dataResult?.data?.content,
        fileName: dataResult?.data?.name
      };
    }

    throw new Error("Failed to get recording");
  } catch (e) {
    throw "File download failed";
  }
}

export async function getResourceFile({ url, Reference, ReferenceId, accessToken } : GetResourceFileParams ) {
    try {
        const response = await  ( await  makeRequest(accessToken, url + `/resources?Reference=${Reference}&Type=2&ReferenceId=${ReferenceId}`, 'GET', null, null ));
        const dataResult = await response.json();
        if (response.ok){
            return {status:"success", message:  "User update success" , resource: dataResult?.data?.content};
        }
    }catch (e) {
        throw "File upload failed"
    }
}       

export async function uploadToqueue ({Reference, ReferenceId,accessToken,url}: UploadFileParams) {
    try {
        const response = (await makeRequest(accessToken, url + `?Reference=${Reference}&Type=2&ReferenceId=${ReferenceId}`, 'POST', null, ''));
        const dataResult = await response.json();
        if (response.ok){
            return {status:"success", message:  "File upload success" , name: dataResult?.data?.name};
        }
    }catch (e) {
        throw "File upload failed"
    }
}
